//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Как считать комиссию WB из отчёта <c>reportDetailByPeriod</c> при синхронизации заказов. */
export enum WbCommissionCalculationMode {
  /** Сумма удержаний по строкам (логистика, эквайринг, вознаграждение WB с НДС и т.д.). */
  DetailedDeductions = 0,
  /**
  * По строке: «Цена розничная с учётом согласованной скидки» минус «К перечислению продавцу за реализованный
  *               товар» плюс логистика (<c>delivery_rub</c>, <c>rebill_logistic_cost</c>), хранение (<c>storage_fee</c>),
  *               прочие удержания/выплаты (<c>deduction</c>), штрафы (<c>penalty</c>).
  */
  RetailMinusForPayWithLogistics = 1
}
